import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import error from "../../utils/error";

const defaultShiftDetailsData = {
  isLoading: false,
  status: "",
  data: [],
  error: undefined
};

const initialShiftDetailsState: any = {
  userList: defaultShiftDetailsData,
  logList: defaultShiftDetailsData
};

export const getShiftUserList = createAsyncThunk(
  "shift/userList",
  async (payload: any) => {
    try {
      return payload;
    } catch (error_) {
      return error_;
    }
  }
);

export const getShiftLogList = createAsyncThunk(
  "shift/logList",
  async (payload: any) => {
    try {
      return payload;
    } catch (error_) {
      return error_;
    }
  }
);

const shiftSlice = createSlice({
  name: "shift",
  initialState: initialShiftDetailsState,
  reducers: {
    selectBackupAction: (state, action) => {
      state.selectBackup = action.payload;
    }
  },
  extraReducers(builder): void {
    builder.addCase(getShiftUserList.pending, (state) => {
      state.userList.isLoading = true;
    });
    builder.addCase(getShiftUserList.fulfilled, (state, action) => {
      state.userList.isLoading = false;
      state.userList.data = action.payload;
    });
    builder.addCase(getShiftUserList.rejected, (state, action) => {
      state.userList.isLoading = false;
      state.userList.error = error(action.payload);
    });

    builder.addCase(getShiftLogList.pending, (state) => {
      state.logList.isLoading = true;
    });
    builder.addCase(getShiftLogList.fulfilled, (state, action) => {
      state.logList.isLoading = false;
      state.logList.data = action.payload;
    });
    builder.addCase(getShiftLogList.rejected, (state, action) => {
      state.logList.isLoading = false;
      state.logList.error = error(action.payload);
    });
  },
});

export default shiftSlice.reducer;
export const { selectBackupAction } = shiftSlice.actions;